import React from "react";

// Components
import PartnerImages from "../partner-images/PartnerImages";

// Styles
import styles from "./contact-us-chat-banner.module.scss";
import LiveChatButton from "../live-chat-button/LiveChatButton";

function ContactUsChatBanner({ channel = null, location = null }) {
  return (
    <div className={styles.chatBanner}>
      <div className={styles.leftSection}>
        <h3>LIVE CHAT WITH OUR PARTNERS</h3>
        <p>During temporary store closures, our in-store Partners are supporting our customer service team.</p>
        <div className={styles.buttonWrapper}>
          <LiveChatButton channel={channel} buttonLocation={location} />
        </div>
      </div>
      <div className={styles.imageWrapper}>
        <PartnerImages partners={3} partnersTablet={4} />
      </div>
    </div>
  );
}

export default ContactUsChatBanner;
